// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { DELETE_MESSAGE, ERROR_MESSAGE } from "../../common/Constant";
// import { toastError, toastSuccess } from "../../common/Toast";
// import {
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Button,
// } from "@mui/material";

// const DeleteConfirmationModalBanner = ({
//   deleteApiUrl,
//   open,
//   onClose,
//   dynamicValue,
//   openingbalance = 0,
//   isAccountingDelete = 0,
//   isshowDeleteWarning = 0,
//   isSaleVoid = 0,
// }) => {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);

//   const handleSubmit = () => {
//     setLoading(true);
//     const token = localStorage.getItem("Token");
//     const deleteRequestParam = JSON.parse(localStorage.getItem("DeleteRequestParam") || "{}");

//     const payload = {
//       ID: deleteRequestParam.ID,
//       from: dynamicValue,
//       ...(deleteRequestParam.module && { module: deleteRequestParam.module }),
//     };

//     axios
//       .post(deleteApiUrl, deleteRequestParam, {
//         headers: {
//           "Content-Type": "application/json;charset=UTF-8",
//           Authorization: token,
//         },
//       })
//       .then((res) => {
//         setLoading(false);
//         if (res.data.ResponseCode === "ERROR") {
//           toastError(ERROR_MESSAGE);
//         } else {
//           if (isSaleVoid == 1) {
//           toastSuccess("Sale has been voided successfully!");
//           return navigate("/sales");
//          } else {
//           toastSuccess(DELETE_MESSAGE);
//           isAccountingDelete === 1 ? navigate(-1) : onClose();
//          }
//         }
//       })
//       .catch((error) => {
//         console.error("Error during deletion:", error);
//         setLoading(false);
//         onClose();
//       });
//   };

//   return (
//     <Dialog open={open}>
//       {Number(openingbalance) === 0 && (
//         <DialogTitle textAlign="center">Confirmation</DialogTitle>
//       )}
//       <DialogContent>
//         {Number(openingbalance) > 0
//           ? "You Cannot Delete this Record Because Your Opening Balance is Greater than Zero"
//           : Number(isshowDeleteWarning) > 0
//           ? "Are you sure you want to delete this record? Some items are linked to sales or receivings. Deleting them may affect existing records."
//            : isSaleVoid == 1
//           ? "The sale balance will go to zero, and your customer won't be able to pay it. You can't undo this."
//           : "Are you sure you want to delete this record?"}
//       </DialogContent>
//       <DialogActions sx={{ p: "1.25rem" }}>
//         <Button className="btn btn-sm btn-outline-dark" onClick={onClose}>
//           {Number(openingbalance) > 0 ? "OK" : "Cancel"}
//         </Button>
//         {Number(openingbalance) === 0 && (
//           <Button
//             className="btn btn-sm btn-primary"
//             onClick={handleSubmit}
//             variant="contained"
//             disabled={loading}
//           >
//             {isSaleVoid == 1 ? "Void Sale" : "Delete"}
//           </Button>
//         )}
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default DeleteConfirmationModalBanner;









import React, { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import { DELETE_MESSAGE, ERROR_MESSAGE } from "../../common/Constant";
import { toastError, toastSuccess } from "../../common/Toast";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";

const DeleteConfirmation = ({
  deleteApiUrl,
  open,
  data11,
  onClose,
  quickbookarray,
  openingbalance,
  isAccountingDelete,
  isshowDeleteWarning = 0,
  isSaleVoid = 0
}) => {
  console.log(open, data11, "220520");
  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const handleSubmit = () => {
    //put your validation logic here
    const token = localStorage.getItem("Token");
    const deleteRequestParam = localStorage.getItem("DeleteRequestParam");
    console.log(deleteRequestParam, "deleterdata");

    if (isAccountingDelete == 1) {
      setLoading(true);
    }

    axios
      .post(`${deleteApiUrl}`, deleteRequestParam, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        if (isAccountingDelete == 1) {
          setLoading(false);
        }
        if (res.data.ResponseCode === "ERROR") {
          toastError(ERROR_MESSAGE);
          onClose();
          return;
        }
         if (isSaleVoid == 1) {
          toastSuccess("Sale has been voided successfully!");
          return navigate("/sales");
         } else {
          toastSuccess(DELETE_MESSAGE);
          isAccountingDelete == 1
            ? navigate(-1)
            : data11 == true
            ? onClose()
            : (deleteApiUrl.includes("/offerdelete") ? onClose() : window.location.reload());
            // : window.location.reload();
         }
      })
      .catch((error) => {
        console.error("Error during deletion:", error);

        onClose();
      });

    onClose();
  };


  return (
    <Dialog open={open}>
      {Number(openingbalance) == 0 ? (
        <DialogTitle textAlign="center">Confirmation</DialogTitle>
      ) : (
        ""
      )}
      <DialogContent>
        {Number(openingbalance) > 0
          ? "You Cannot Delete this Record Because Your Opening Balance is Greater than Zero"
          : Number(isshowDeleteWarning) > 0
          ? "Are you sure you want to delete this record? Some items are linked to sales or receivings. Deleting them may affect existing records."
          : isSaleVoid == 1
          ? "The sale balance will go to zero, and your customer won't be able to pay it. You can't undo this."
          : "Are you sure you want to delete this record?"}
      </DialogContent>
      {Number(openingbalance) > 0 ? (
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button class="btn btn-sm btn-primary" onClick={onClose}>
            OK
          </Button>
        </DialogActions>
      ) : (
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button class="btn btn-sm btn-outline-dark" onClick={onClose}>
            Cancel
          </Button>
          <Button
            class="btn btn-sm btn-primary"
            onClick={handleSubmit}
            variant="contained"
          >
            {isSaleVoid == 1 ? "Void Sale" : "Delete"}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );



};

export default DeleteConfirmation;

// const handleSubmit = () => {
//   //put your validation logic here
//   const token = localStorage.getItem("Token");
//   const deleteRequestParam = localStorage.getItem("DeleteRequestParam");
//   console.log(deleteRequestParam,"deleterdata")

//  if(isAccountingDelete == 1){
//   setLoading(true);
//  };

//   axios
//     .post(`${deleteApiUrl}`, deleteRequestParam, dynamicValue, {
//       headers: {
//         "Content-Type": "application/json;charset=UTF-8",
//         Authorization: token,
//       },
//     })
//     .then((res) => {
//       if(isAccountingDelete == 1){
//         setLoading(false);
//        };
//       if(res.data.ResponseCode === "ERROR"){
//         toastError(ERROR_MESSAGE);
//         onClose();
//         return
//       }
//       toastSuccess(DELETE_MESSAGE);
//       isAccountingDelete == 1 ? navigate(-1) : data11 == true ? onClose() : window.location.reload();

//     })
//     .catch((error) => {
//       console.error("Error during deletion:", error);

//       onClose();
//     });

//   onClose();
// };

//   const deleteRequestParam = localStorage.getItem("DeleteRequestParam"); // string
// console.log(deleteRequestParam.ID , "check delete id value")
// console.log(deleteRequestParam.ID, "check delete id value");
